// extracted by mini-css-extract-plugin
export default {"bannerCont":"Banner_bannerCont__SR5cm","imgBox":"Banner_imgBox__DsvwS","title":"Banner_title__+xhl6"};